"use client";

import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PeeqdPricing } from "@/components/peeqd/PeeqdMarketing";

interface PricingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function PricingModal({ isOpen, onClose }: PricingModalProps) {

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[10001]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-ink/50 backdrop-blur-[2px]" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 sm:p-6">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative w-full max-w-5xl overflow-hidden rounded-3xl border border-line bg-bg shadow-card">
                <button
                  type="button"
                  onClick={onClose}
                  className="absolute right-4 top-4 z-10 rounded-full border border-line bg-surface px-3 py-1.5 text-[13px] font-medium text-muted transition hover:text-ink"
                >
                  Close
                </button>

                <div className="max-h-[min(88vh,900px)] overflow-y-auto px-4 pb-6 pt-10 sm:px-8">
                  <div className="mb-2 text-center">
                    <p className="text-[12px] font-semibold uppercase tracking-widest text-rose-deep">
                      Subscription required
                    </p>
                    <Dialog.Title className="mt-2 font-display text-[24px] font-bold text-ink sm:text-[28px]">
                      Choose a plan to start tracking
                    </Dialog.Title>
                    <p className="mx-auto mt-2 max-w-xl text-[14px] leading-relaxed text-muted">
                      Connect and monitor one public Instagram account with real timestamps.
                      Pick a billing interval below to continue.
                    </p>
                  </div>

                  <PeeqdPricing
                    currentUserPriceId={null}
                    className="pt-6"
                    priceLayout="interval-weekly"
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
